import isPropValid from '@emotion/is-prop-valid';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { StyleSheetManager, ThemeProvider } from 'styled-components';

import App from './App';
import { ToastProvider } from './components/CustomFeedback/CustomToast';
import { AuthProvider } from './modules/contexts/Auth/AuthProvider';
import HydrationGate from './modules/contexts/Auth/TokenHydrator';
import TokenRefreshManager from './modules/contexts/Auth/TokenRefreshManager';
import { ColorProvider } from './modules/contexts/Color/ColorProvider';
import { SelectProvider } from './modules/contexts/Select/SelectProvider';
import { UserProvider } from './modules/hooks/userContext';
import reportWebVitals from './reportWebVitals';
import theme from './theme';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <UserProvider>
        <HashRouter>
          <HydrationGate>
            <TokenRefreshManager>
              <ThemeProvider theme={theme}>
                <StyleSheetManager
                  shouldForwardProp={(prop, element) => {
                    if (prop.startsWith('$')) {
                      return false;
                    }
                    if (typeof element === 'string') {
                      return isPropValid(prop);
                    }
                    return true;
                  }}
                >
                  <SelectProvider>
                    <ColorProvider>
                      <ToastProvider>
                        <App />
                      </ToastProvider>
                    </ColorProvider>
                  </SelectProvider>
                </StyleSheetManager>
              </ThemeProvider>
            </TokenRefreshManager>
          </HydrationGate>
        </HashRouter>
      </UserProvider>
    </AuthProvider>
  </React.StrictMode>,
);

reportWebVitals();
